import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphUTMOverall } from "./utmOverallAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  addtocart: [],
  bought: [],
  weeks: [],
  labels: [],
};

export const graphUTMOverall = createAsyncThunk(
  "utmOverall/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-socialCountInsights`;
      const response = await fetchGraphUTMOverall(dbpath, user, 'graph-socialCountInsights');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmOverallSlice = createSlice({
  name: "utmOverall",
  initialState,
  reducers: {
    resetutmOverall: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMOverall.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMOverall.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        try {
          state.data = result;
          const resultData = utmOverallHandler(result);
          state.visitors = resultData.visitors.reverse();
          state.addtocart = resultData.addtocart.reverse();
          state.bought = resultData.bought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          console.error(error);
        }
      })
      .addCase(graphUTMOverall.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetutmOverall} = utmOverallSlice.actions;


export default utmOverallSlice.reducer;

export const SelectVisitors = (state) => state.utmOverall.visitors;
export const SelectPercentBooking = (state) => state.utmOverall.addtocart;
export const SelectPercentBought = (state) => state.utmOverall.bought;
export const SelectLabels = (state) => state.utmOverall.labels;
export const SelectWeeks = (state) => state.utmOverall.weeks;
export const SelectUTMOverallStatus = (state) => state.utmOverall.status;

function convertDate(input) {
  // Use regex to capture year, month, and day parts
  return input.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
}

export const utmOverallHandler = (data) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    addtocart: [],
    bought: [],
    labels: [],
  };

  for (let [key, val] of Object.entries(data[0])) {
    resultObj.weeks.push(convertDate(key));
    resultObj.labels.push(val[1]);
    resultObj.visitors.push(val[0][0]['data']);
    resultObj.addtocart.push(val[0][1]['data']);
    resultObj.bought.push(val[0][2]['data']);
  }

  return resultObj;
};